const AUTH_ROUTES = {
  login: 'auth/sign_in',
  logout: 'auth/sign_out',
}

export default AUTH_ROUTES
